import { render, staticRenderFns } from "./TermsPayButtonRecurrent.vue?vue&type=template&id=40e74196"
import script from "./TermsPayButtonRecurrent.vue?vue&type=script&lang=js"
export * from "./TermsPayButtonRecurrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports